import { Offer } from '../models/offers.model';

export enum FirestoreCollection {
  OFFERS = 'offers',
  OFFERS_PUBLIC = 'offersPublic',
  CONTRACTS = 'contracts',
  USERS = 'users',
  ADMIN = 'admin',
  COMPANIES = 'companies',
  SESSIONS = 'sessions',
  EVENTS = 'events',
  CALLERS = 'callers',
  MOBYWATEL_REQUESTS = 'mobywatelRequests',
  AGENCY_AGREEMENTS = 'agencyAgreements',
}

export enum CollectionLegalEntity {
  TENANT = 'tenant',
  LANDLORD = 'landlord',
}

export interface OfferOption {
  id: number;
  title: string;
  qualifiedSignature: boolean;
}

export interface FunctionSignOfferPayload {
  offer: Offer;
  selectedOfferOption: OfferOption;
}
export interface onBookOfferPayload {
  offerId: string;
  selectedOfferOption: OfferOption;
}
export interface FunctionAddOfferPayload {
  offerId: string;
}
export interface FunctionSignOfferConfirmPayload {
  offerId: string;
  userUid: string;
}
export interface FunctionAskQuestion {
  offerName: string;
  title: string;
  description: string;
  tenant: string;
  offerId: string;
}

export interface User {
  uid: string;
  firstName: string;
  lastName: string;
}

export enum FirebaseCallableFunctions {
  ON_OFFER_SIGN = 'onOfferSign',
  ON_OFFER_ADD = 'onOfferAdd',
  ON_OFFER_ADD_CONFIRM = 'onOfferAddConfirm',
  ON_OFFER_SIGN_CONFIRM = 'onOfferSignConfirm',
  ON_NEW_USER = 'onNewUser',
  ADD_TO_FAVORITES = 'addToFavorites',
  ON_CREATE_OFFER = 'onCreateOffer',
  ON_DELETE_ACCOUNT_CONFIRM = 'onDeleteAccountConfirm',
  ON_REPORT = 'onReport',
  ON_UPLOAD_SIGNATURE = 'onUploadSignature',
  ON_ADD_COMPANY = 'onAddCompany',
  ON_ASK_QUESTION = 'onAskQuestion',
  ON_PROTOCOL_ATTACHED = 'onProtocolAttached',
  NOTIFY_ADMIN_ON_CONTRACT_SIGNED = 'notifyAdminOnContractSigned',
  ON_COUNTER_OFFER = 'onCounterOffer',
  ON_COUNTER_OFFER_DECLINED = 'onCounterOfferDeclined',
  ON_COUNTER_OFFER_ACCEPTED = 'onCounterOfferAccepted',
  REMOVE_FROM_FAVORITES = 'removeFromFavorites',
  GENERATE_OFFER_PDF_AND_UPLOAD = 'generateOfferPdfAndUpload',
  ON_BOOK_OFFER = 'onBookOffer',
  ON_REJECT_PROTOCOL = 'onRejectProtocol',
  CONFIRM_OR_DECLINE_PROTOCOL = 'confirmOrDecline',
  MAIL_NEW_OFFER = 'mailNewOffer',
  VERIFY_PHOTOS = 'verifyPhotos',
  VERIFY_PHOTOS_VISION = 'verifyPhotosVision',
  VERIFY_PHOTOS_GEMINI = 'verifyPhotosGemini',
  SEND_EMAIL_VERIFICATION_CODE = 'sendEmailVerificationCode',
  VERIFY_EMAIL_VERIFICATION_CODE = 'verifyEmailVerificationCode',
  VIEW_EMAIL = 'viewEmail',
  ON_CALL_REGON_API = 'onCallRegonAPI',
  IS_COMPANY_ALREADY_IN_FIRESTORE = 'isCompanyAlreadyInFirestore',
  ON_SUBMIT_COMPANY = 'onSubmitCompany',
  UPDATE_USER_COMPANY_ID = 'updateUserCompanyId',
  CLEAR_COMPANY_DETAILS_IN_USER_DATA = 'clearCompanyDetailsInUserData',
  DELETE_COMPANY = 'deleteCompany',
  DELETE_USER_FROM_COMPANY = 'deleteUserFromCompany',
  GET_PLACE_ID = 'getPlaceId',
  GET_INVOICE_NUMBER_TO_TRANSACTION = 'getInvoiceNumberToTransaction',
  ON_ASK_GEMINI_ABOUT_FAQ = 'onAskGeminiAboutFAQ',
  ADD_ADMIN_CLAIM = 'addAdminClaim',
  ADD_CREATOR_CLAIM = 'addCreatorClaim',
  ADD_OFFER_TO_COMPANY = 'addOfferToCompany',
  DELETE_ALL_USER_DATA = 'DeleteAllUserData',
  LINK_PROJECT_OFFER = 'linkProjectOffer',
  LINK_PROJECT_OFFER_FOR_AGENT = 'linkProjectOfferForAgent',
  ACCEPT_AGENCY_AGREEMENT = 'acceptAgencyAgreement',
  REVOKE_AGENCY_AGREEMENT = 'revokeAgencyAgreement',
  GET_AGENCY_AGREEMENT_BY_TOKEN = 'getAgencyAgreementByToken',
  REQUEST_AGENCY_AGREEMENT_CONFIRMATION = 'requestAgencyAgreementConfirmation',
  CONFIRM_AGENCY_AGREEMENT_WITH_TOKEN = 'confirmAgencyAgreementWithToken',
  UPDATE_RECEPTION_OF_THE_PREMISE = 'updateReceptionOfThePremise',
  ON_CLICK_OFFER_ADD_LINK = 'onClickOfferAddLink',
  CALLER_SEND_OFFER = 'callerSendOffer',
  CALLER_SEND_WEBSITE = 'callerSendWebsite',
  GENERATE_UTM_LINK = 'generateUtmLink',
  ON_SHOW_MOBYWATEL_INSTRUCTIONS = 'onShowMObywatelInstructions',
  ON_REQUEST_MOBYWATEL_VERIFICATION = 'onRequestMObywatelVerification',
  UPDATE_MOBYWATEL_CODE = 'updateMObywatelCode',
  CONFIRM_MOBYWATEL_VERIFICATION = 'confirmMObywatelVerification',
  HANDLE_CONTINUE_VERIFICATION = 'handleContinueVerification',
  SHOW_USER_MODAL = 'showUserModal',
  RESET_VERIFICATION = 'resetVerification',
  SUBMIT_OFFER_TO_WANTED_LISTING = 'submitOfferToWantedListing',
  PLACES_AUTOCOMPLETE = 'placesAutocomplete',
  GET_PLACE_DETAILS = 'getPlaceDetails',
}
